import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Heart, Trash2 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { COURSES, getWishlist, toggleWishlist } from '@/lib/data';
import CourseCard from '../components/shared/CourseCard';

export default function Wishlist() {
  const [wishlist, setWishlist] = useState(getWishlist());
  const courses = wishlist.map(id => COURSES.find(c => c.id === id)).filter(Boolean);

  const remove = (id) => {
    toggleWishlist(id);
    setWishlist(prev => prev.filter(wid => wid !== id));
  };

  return (
    <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} className="space-y-6">
      <div>
        <h1 className="font-heading text-2xl font-bold">Wishlist</h1>
        <p className="text-muted-foreground text-sm mt-1">{courses.length} saved course{courses.length !== 1 ? 's' : ''}</p>
      </div>

      {courses.length > 0 ? (
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {courses.map((course, i) => (
            <div key={course.id} className="relative">
              <CourseCard course={course} index={i} />
              <button
                onClick={() => remove(course.id)}
                className="absolute top-3 right-3 z-10 w-8 h-8 rounded-full bg-red-100 flex items-center justify-center hover:bg-red-200 transition-colors"
              >
                <Trash2 className="w-4 h-4 text-red-600" />
              </button>
            </div>
          ))}
        </div>
      ) : (
        <div className="text-center py-20 bg-card rounded-xl border">
          <Heart className="w-12 h-12 text-muted-foreground/30 mx-auto mb-4" />
          <h3 className="font-heading font-semibold text-lg">Your wishlist is empty</h3>
          <p className="text-muted-foreground text-sm mt-1">Save courses you're interested in!</p>
          <Link to="/courses"><Button className="mt-4">Browse Courses</Button></Link>
        </div>
      )}
    </motion.div>
  );
}